module.exports = __webpack_public_path__ + "img/visa.f6d3e40.png";